module.exports = __webpack_public_path__ + "static/rastaman-b6828a21441c701a1eda6ad9ee3b3460.png";